<template>
  <nav class="bottom-nav">
    <template v-for="(item, index) in items">
      <div
        :class="['bottom-nav-btn', btnclass, {active: currentNav === index}]"
        :key="index"
        @click="clickNav(index)"
      >
        <div class="icon" :style="btnIcon(index)"></div>
        <span :style="lngStyle">{{ $t(`tabs.${page}.${item.name}`) }}</span>
      </div>
    </template>
  </nav>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: {
    page: String,
    items: Array,
    active: Number,
    btnclass: String,
    icon: Object,
    wrap: Boolean
  },
  data() {
    return {
      currentNav: this.active || 0
    };
  },
  computed: {
    ...mapState(["locale"]),
    ...mapGetters(["lngClass"]),
    iconDefault() {
      return this.icon
        ? { backgroundImage: `url(${this.icon.iconUrlDefault})` }
        : {};
    },
    iconActive() {
      return this.icon
        ? { backgroundImage: `url(${this.icon.iconUrlActive})` }
        : {};
    },
    lngStyle() {
      if (this.lngClass && this.wrap) {
        const ruStyle = this.locale === "ru" ? { fontWeight: "500" } : {};
        return {
          whiteSpace: "normal",
          ...ruStyle
        };
      }
    }
  },
  methods: {
    btnIcon(index) {
      const { btn, btnactive } = this.items[index];
      if (btn) {
        let icon = this.currentNav === index ? btnactive : btn;
        return { backgroundImage: `url("${icon}")` };
      } else if (this.icon) {
        return this.currentNav === index ? this.iconActive : this.iconDefault;
      }
    },
    clickNav(index) {
      this.currentNav = index;
      this.$emit("changeNav", index);
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.bottom-nav {
  display: flex;
  position: absolute;
  bottom: 2rem;
  @include center-x;
}

.bottom-nav-btn {
  flex: 1;
  position: relative;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  color: $text;
  font-size: 0.75rem;
  font-weight: 900;
  text-align: center;

  .icon {
    margin: auto;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    background-repeat: no-repeat;
    background-size: 100%;
  }

  span {
    display: block;
    line-height: 1.2;
    white-space: nowrap;
  }
}

.bottom-nav-btn.active {
  color: $primary;

  &::after {
    content: "";
    display: block;
    height: 1px;
    background-color: $primary;
  }
}
</style>
